export const TOKEN = 'token';
export const URL = 'url';
export const USERNAME = 'username';
export const OLDLOGIN = 'oldlogin';
